const PUBLIC_CHECKOUT_ORIGIN = 'https://canxp.ai';

export function isElectronCheckoutEnvironment() {
  return typeof window !== 'undefined' && Boolean(
    window.electronAPI?.isElectron ||
    (typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().includes('electron'))
  );
}

export function getCheckoutReturnOrigin() {
  return isElectronCheckoutEnvironment() ? PUBLIC_CHECKOUT_ORIGIN : window.location.origin;
}

export function buildDesktopAppReturnUrl(pathname: string, params: URLSearchParams | Record<string, string>) {
  const searchParams = params instanceof URLSearchParams
    ? new URLSearchParams(params)
    : new URLSearchParams(Object.entries(params).filter(([, value]) => value));

  const query = searchParams.toString();
  return `mapleos://app${pathname}${query ? `?${query}` : ''}`;
}

export async function openCheckoutUrl(url: string) {
  if (isElectronCheckoutEnvironment() && window.electronAPI?.openCheckout) {
    await window.electronAPI.openCheckout(url);
    return 'in-app-modal' as const;
  }

  if (isElectronCheckoutEnvironment() && window.electronAPI?.openExternal) {
    await window.electronAPI.openExternal(url);
    return 'external' as const;
  }

  window.location.href = url;
  return 'same-window' as const;
}